import React from 'react'
import styles from './Container.module.scss'
import classNames from 'classnames'

export default function Container({
  children,
  size = 'regular',
  className,
  style,
  isGrid,
  containerId,
  onMouseMove,
}: {
  children: React.ReactNode
  size?: 'small' | 'regular' | 'large'
  className?: string | string[]
  style?: React.CSSProperties
  isGrid?: boolean
  containerId?: string
  onMouseMove?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) {
  return (
    <div
      className={classNames(
        styles.container,
        { [styles.small]: size === 'small' },
        { [styles.large]: size === 'large' },
        { [styles.grid]: isGrid },
        className
      )}
      style={style}
      id={containerId}
      onMouseMove={onMouseMove}
    >
      {children}
    </div>
  )
}
